/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RepairTaskBuildingEquipmentDto } from './repairTaskBuildingEquipmentDto';
import { CheckpointItemDto } from './checkpointItemDto';
import { InspectionEntryItemDto } from './inspectionEntryItemDto';
import { RepairTaskBuildingDto } from './repairTaskBuildingDto';
import { RepairTaskPermissions } from './repairTaskPermissions';
import { TenantItemDto } from './tenantItemDto';
import { BuildingSectionItemDto } from './buildingSectionItemDto';


export interface RepairTaskItemDto { 
    id: string;
    title: string;
    description: string;
    status: RepairTaskItemDto.StatusEnum;
    deadline?: string;
    inspectionEntry?: InspectionEntryItemDto;
    contractor?: TenantItemDto;
    permissions: RepairTaskPermissions;
    inspectionEntryCheckpoint?: CheckpointItemDto;
    buildingSection?: BuildingSectionItemDto;
    building?: RepairTaskBuildingDto;
    buildingEquipment?: RepairTaskBuildingEquipmentDto;
    creatorTenant?: TenantItemDto;
    creatorName?: string;
    created: string;
    sentAt?: string;
    finishedAt?: string;
    declinedAt?: string;
}
export namespace RepairTaskItemDto {
    export type StatusEnum = 'DRAFT' | 'TODO' | 'IN_PROGRESS' | 'FINISHED' | 'DECLINED';
    export const StatusEnum = {
        Draft: 'DRAFT' as StatusEnum,
        Todo: 'TODO' as StatusEnum,
        InProgress: 'IN_PROGRESS' as StatusEnum,
        Finished: 'FINISHED' as StatusEnum,
        Declined: 'DECLINED' as StatusEnum
    };
}


